import { render, staticRenderFns } from "./UpdateEducation.vue?vue&type=template&id=6e1979c9&scoped=true"
import script from "./UpdateEducation.vue?vue&type=script&lang=js"
export * from "./UpdateEducation.vue?vue&type=script&lang=js"
import style0 from "./UpdateEducation.vue?vue&type=style&index=0&id=6e1979c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1979c9",
  null
  
)

export default component.exports